import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Collapse,
  NavItem,
  NavLink
} from "shards-react";

import { getProfile } from "../../../auth/UserFunctions";
import history from "../../../../history";

export default class UserActions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      name: ""
    };

    this.state = {
      visible: false
    };

    this.toggleUserActions = this.toggleUserActions.bind(this);
    this.logOut = this.logOut.bind(this);
  }

  toggleUserActions() {
    this.setState({
      visible: !this.state.visible
    });
  }

  logOut(e) {
    e.preventDefault();
    localStorage.removeItem("userData");
    localStorage.removeItem("userName");
    localStorage.removeItem("userEmail");
    localStorage.removeItem("userToken");
    localStorage.removeItem("expires_at");
    localStorage.removeItem("userRoles");
    localStorage.removeItem("userLayout");
    window.location.href = "/login";
    //this.props.history.push('/login')
  }

  async componentDidMount() {
    if (!localStorage.getItem("expires_at")) {
      window.location.href = "/login";
    } else {
      var expires_at = new Date(localStorage.getItem("expires_at"));
      var dt = new Date();
      if (dt.getTime() > expires_at.getTime()) {
        localStorage.removeItem("userData");
        localStorage.removeItem("userName");
        localStorage.removeItem("userEmail");
        localStorage.removeItem("userToken");
        localStorage.removeItem("userRoles");
        localStorage.removeItem("userLayout");
        localStorage.removeItem("expires_at", expires_at);
        window.location.href = "/token-expired";
      } else {
        var userName = localStorage.getItem("userName");
        var userEmail = localStorage.getItem("userEmail");
        if (!userName && !userEmail) {
          await getProfile().then(res => {
            if (!res) {
              localStorage.removeItem("userName");
              localStorage.removeItem("userData");
              localStorage.removeItem("userEmail");
              localStorage.removeItem("userRoles");
              localStorage.removeItem("expires_at", expires_at);
              localStorage.removeItem("userLayout");
              window.location.href = "/token-expired";
            } else {
              userName = res.name;
              userEmail = res.email;
            }
          });
        }
        this.setState({ name: userName, email: userEmail });
      }
    }
  }

  render() {
    return (
      <NavItem tag={Dropdown} caret toggle={this.toggleUserActions}>
        <DropdownToggle caret tag={NavLink} className="text-nowrap px-3">
          <img
            className="user-avatar rounded-circle mr-1"
            src={require("./../../../../images/avatars/user.png")}
            alt="User Avatar"
          />{" "}
          <span className="d-none d-md-inline-block">{this.state.name}</span>
        </DropdownToggle>
        <Collapse tag={DropdownMenu} right small open={this.state.visible}>
          <DropdownItem tag={Link} to="edit-user-profile">
            <i className="material-icons">&#xE8B8;</i> Mi perfil
          </DropdownItem>
          <DropdownItem tag={Link} to="change-password">
            <i className="material-icons">lock</i> Cambiar mi contraseña
          </DropdownItem>
          {/* <DropdownItem tag={Link} to="file-manager-list">
            <i className="material-icons">&#xE2C7;</i> Files
          </DropdownItem>
          <DropdownItem tag={Link} to="transaction-history">
            <i className="material-icons">&#xE896;</i> Transactions
          </DropdownItem>
          <DropdownItem divider /> */}
          <DropdownItem
            onClick={this.logOut.bind(this)}
            className="text-danger"
          >
            <i className="material-icons text-danger">&#xE879;</i> Salir
          </DropdownItem>
        </Collapse>
      </NavItem>
    );
  }
}
